import { ref, readonly } from 'vue'

const STORAGE_KEY = 'prompta_selected_client'

// Reactive global state — shared across all components
const _client = ref(null)

function _load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    _client.value = raw ? JSON.parse(raw) : null
  } catch {
    _client.value = null
  }
}

// Initialize from storage on first import
_load()

export function useSelectedClient() {
  const selectedClient = readonly(_client)

  function setClient(client) {
    _client.value = client
    if (client) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(client))
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  function clearClient() {
    setClient(null)
  }

  function hasClient() {
    return !!_client.value?.id
  }

  return { selectedClient, setClient, clearClient, hasClient }
}
